<div class="position-fixed m-auto item-spinner w-100 vh-100 d-flex justify-content-center align-items-center" >
    <div class="spinner-border text-primary" role="status">
        <span class="sr-only">Loading...</span>
    </div>
</div>
